import { Component } from '@angular/core';

import { ChangeDetectionStrategy, signal } from '@angular/core';
import { HttpStatusEnum } from '@core/api';
import { MixpanelService } from '@core/services';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ToasterHelper } from '@shared/helpers';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { OrderSetupApi } from 'src/app/features/orders/order-setup/_core/api';
import { RequestQuoteForCustomWorkModalComponent } from '../request-quote-for-custom-work-modal/request-quote-for-custom-work-modal.component';

@Component({
    selector: 'app-templates-and-forms-section',
    standalone: true,
    imports: [TranslateModule, ButtonModule, TooltipModule, RequestQuoteForCustomWorkModalComponent],
    templateUrl: './templates-and-forms-section.component.html',
    styleUrls: ['./templates-and-forms-section.component.scss'],
    providers: [OrderSetupApi],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TemplatesAndFormsSectionComponent {
    readonly isCustomWorkModalVisible = signal(false);
    readonly isDownloadingTemplate = signal(false);

    constructor(
        private orderSetupApi: OrderSetupApi,
        private mixpanelService: MixpanelService,
        private messageService: MessageService,
        private translateService: TranslateService
    ) {}

    async downloadOrderTemplate() {
        this.isDownloadingTemplate.set(true);
        const response = await this.orderSetupApi.downloadCsvTemplate();
        if (response.status === HttpStatusEnum.SUCCESS) {
            this.mixpanelService.logEvent('dashboard-download-order-csv-template');
            this.messageService.add(
                ToasterHelper.success(
                    this.translateService.instant('dashboard.templatesAndForm.csvOrderPlacementCsv.successMessage')
                )
            );
        }
        this.isDownloadingTemplate.set(false);
    }

    toggleCustomWorkModal() {
        this.isCustomWorkModalVisible.update(value => !value);
        this.mixpanelService.logOpenModal('dashboard-open-custom-work-modal');
    }
}
